import React, { Component } from 'react';

class Sucursales extends Component {
    render() {
        let data = this.props.data;

        if (data) {
            var branchesNodes = data.map((branchesItem) => {
                return (
                    <div key={"checkBranches" + branchesItem.Id} className="row">
                        <div key={"checkBranches" + branchesItem.Id} className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                    <div className="default-checkbox">
                                        <input key={"checkBranches" + branchesItem.Id}
                                            id={"checkBranches" + branchesItem.Id}
                                            name="checkBranches"
                                            type="checkbox"
                                            checked={branchesItem.Checked}
                                            onChange={() => this.props.checkItem(branchesItem.Id)}
                                            value={branchesItem.Checked} />
                                        <label className="label-primary"
                                            htmlFor={"checkBranches" + branchesItem.Id}></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary"
                                        htmlFor={"checkBranches" + branchesItem.Id}>
                                        {branchesItem.VALOR_X + " - " +branchesItem.Descripcion}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                )
            })
        }
        return (
            data != undefined &&
            <div className="row top-separator-xs vertical-scrollable-container-md">
                <div className="col-md-12">
                    {branchesNodes}                    
                </div>
            </div>
        );
    }
};

export default Sucursales;